import { Box, Stack } from '@mui/material';
import { styled } from '@mui/material/styles';
import { useEffect, useState } from 'react';

import { MenRunningAnimation } from '@common/assets';
import { getPercetageValue } from '../../utils';
import { BarGraphRuler } from '../BarGraphRuler';
import { GoalIndicator } from '../GoalIndicator';
import { Container, Heading, LottiePlayer, ProgressBar } from '../GraphStyledElements';
import {
  getColorByDayName,
  getGoalIndicatorAnimation,
  getProgressBarAnimation,
  getRulerSize,
} from '../utils';

const Bar = styled(ProgressBar)(
  ({ color, progress, delay }: { color: string; progress: number; delay: number }) => ({
    width: `${Math.max(0, Math.min(progress, 100)) ?? '0'}%`,
    background: color ?? '#b7ccff',
    animationName: getProgressBarAnimation(progress),
    animationDelay: `${delay ?? 300}ms`,
  })
);

type Props = {
  currentDay: string;
  personalGoal: number | null | undefined;
  todaysGoal: number;
  completedLessons: number;
};

export const DailyProgressGraph = ({
  currentDay,
  todaysGoal,
  completedLessons,
  personalGoal,
}: Props) => {
  const [animation, setAnimation] = useState<any>(MenRunningAnimation);
  const color = getColorByDayName(currentDay);
  const { rulerSize, rulerInterval } = getRulerSize(completedLessons, personalGoal);
  const progress = getPercetageValue(rulerSize, completedLessons);

  useEffect(() => {
    const animation = getGoalIndicatorAnimation({
      completedLessons,
      goal: todaysGoal,
      personalGoal,
    });

    const timeout = setTimeout(() => {
      setAnimation(animation);
    }, 1500);

    return () => {
      clearTimeout(timeout);
    };
  }, [personalGoal, todaysGoal, completedLessons]);

  return (
    <Container>
      <Heading>Today - {currentDay}</Heading>
      <Box position="relative">
        <Stack direction="row">
          <Bar color={color} progress={progress} delay={750} />
          <LottiePlayer autoplay loop src={animation} />
        </Stack>
        <BarGraphRuler size={rulerSize} interval={rulerInterval} />
        {personalGoal !== todaysGoal && (
          <GoalIndicator type="todays_goal" rulerSize={rulerSize} goal={todaysGoal} />
        )}
        {personalGoal && (
          <GoalIndicator type="personal_goal" rulerSize={rulerSize} goal={personalGoal} />
        )}
      </Box>
    </Container>
  );
};
